import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./ProfileSection.css";

const ProfileSection: React.FC = () => (
  <section className="profile-section">

    {/* Main Row */}
    <div className="top-row">

      {/* Image */}
      <div className="profile-picture-wrapper">
        <img
          src="/profile.jpeg"
          alt="Profile"
          className="profile-picture"
        />
      </div>

      {/* Icons stacked vertically */}
      <div className="profile-links-vertical">
        <a
          href="https://linkedin.com/in/riley-corzine-075275217"
          target="_blank"
          rel="noopener noreferrer"
          className="profile-icon"
        >
          <FaLinkedin />
        </a>

        <a
          href="https://github.com/gametekker"
          target="_blank"
          rel="noopener noreferrer"
          className="profile-icon"
        >
          <FaGithub />
        </a>
      </div>

    </div>

  <svg className="greeting-bubble"
      width="300"
      height="70"
      viewBox="0 0 180 70"
      xmlns="http://www.w3.org/2000/svg">
    <path d="M179.43 30H49.4298L0.429764 1L22.4298 30V69.5H49.4298H179.43V30Z"
          fill="#ffffffff"
          stroke="black"
          stroke-width="0" />

    <text x="30" y="55"
          font-family="Arial"
          font-size="17"
          letter-spacing="1.0"
          fill="black">
      Hello, I'm <tspan font-weight="bold">Riley!</tspan>
    </text>
  </svg>



  </section>
);

export default ProfileSection;
